// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"3951":"3990bbf9","7150":"204ccf22"}[chunkId] + ".css";
};